// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueGtag from "vue-gtag";
import jsCookie from "js-cookie";

import 'swiper/css/swiper.min.css'
import 'animate.css'
import 'wowjs/css/libs/animate.css'
import '../static/css/fonts.css'
// import './assets/css/common.scss'
import {WOW} from 'wowjs'
import autoplay from "swiper/src/components/autoplay/autoplay";

Vue.prototype.$cookie = jsCookie
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload, {
  // loading: require('common/image/default.png')
})

//adding VueGtag to enable Google Analytics auto tracking
Vue.use(VueGtag, {
  config: { id: "UA-203879380-1" }
}, router);

// Vue.http.interceptors.push((request,next)=>{
//   console.log(`getParameters('lan')`);
//
//   next(function(response){
//     return response;
//   });
// })

router.beforeEach((to, from, next) => {

  const getParameters = (ky) => {
    let url = window.location.search;
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1]);
      }
    }
    return theRequest[ky] == undefined ? '' : theRequest[ky];
  }

  let lan = getParameters('lan');
  if(lan != ''){
    // jsCookie.set('language', lan, { expires: 7 });
    // Vue.http.headers.common['token'] = 'YXBpOnBhc3N3b3Jk';
    // Vue.defaults.headers.common['token'] = 'YXBpOnBhc3N3b3Jk';
    // console.log(getParameters('lan'));
  }

  if(lan == 'en' || lan == 'en/'){

  }
  // if(){
  //   console.log(from.query.lan);
  // }
  // to.query = 'us';
  // to.fullPath= `${to.path}?lan=en`
  if(jsCookie.get('x-language') == 'en'){
    // router.replace(`${to.path}?lan=en`);

  }

  // console.log(from);
  // console.log(to);

  /* 路由发生变化修改页面title */
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let tagsmeta = document.getElementsByTagName('meta');
    let hasDescriptionOrKeywords = false;
    for(var i=0; i<tagsmeta.length; i++){
      if(tagsmeta[i].getAttribute('name') == 'description'){
        tagsmeta[i].setAttribute('content',to.meta.content);
        hasDescriptionOrKeywords = true;
      }
      if(tagsmeta[i].getAttribute('name') == 'keywords'){
        tagsmeta[i].setAttribute('content',to.meta.keywords);
        hasDescriptionOrKeywords = true;
      }
    }
    if(!hasDescriptionOrKeywords){
      let meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = to.meta.content;
      head[0].appendChild(meta);
      let meta2 = document.createElement('meta');
      meta2.name = 'keywords';
      meta2.content = to.meta.keywords;
      head[0].appendChild(meta2);
    }


  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js